import { Formik } from 'formik';
import { useContext, useState, useEffect } from 'react';
import { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import { api } from '../../services/api';
import { UserData } from '../../types/userData';
import { validationSchema } from '../EditUserData';
import PhoneForm from '../EditUserData/PhoneForm/PhoneForm';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import { Actions, Categories, GetInterventionCategory } from '../../types/gtm';
import { Constraints } from '../../types/underageUser';

import {
  ModalButtons,
  ModalBody,
  ModalParaghaph,
  TextHeaderModal,
  ModalHeader,
  PolicyPrivacy,
} from './styles';
import inputMask from '../../util/mask';
import { ModalContext } from '../../components/PopUpIntervention';
import { useAuth } from '../../hooks/useAuth';
import DocumentForm from '../EditUserData/DocumentForm/DocumentForm';

type MessageIntervention = {
  type: string;
  title: string;
  description: string;
  dialogTitle: string;
  dialogDescription: string;
};

export interface Props {
  messageFields: MessageIntervention;
  userData: any;
  onConfirm?: () => void;
}

const defaultValue = {
  minAge: 13,
};

export default function ModalConfirm({
  messageFields,
  userData,
  onConfirm,
}: Props) {
  const handleFormSubmit = async (
    values: UserData,
    initialValues: UserData,
  ) => {
    const body = values;

    if (initialValues === values) {
      toast.info('Nenhuma informação alterada para salvar');
      return;
    }

    if (body.phones && body.phones.cellPhone) {
      const unmaskPhone = inputMask.unMask(body.phones.cellPhone);
      body.phones.cellPhone = unmaskPhone.substring(2, 16);
      body.phones.dddCellPhone = unmaskPhone.substring(0, 2);
    }
  };

  const context = useContext(ModalContext);
  const { authenticateOnAPI } = useAuth();
  const [openModal, setOpenModal] = useState(context.context);
  const [minAge, setMinAge] = useState<number>(defaultValue.minAge);

  const { user } = useAuth();

  useEffect(() => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: GetInterventionCategory(user, messageFields),
      event_action: Actions.Pageview,
      event_label: 'Tela de Intervencao',
      bd_suser_code: user?.globoId,
    });
  }, []);

  const closeModal = (value: boolean) => {
    setOpenModal(value);
  };

  const getMinAgeParental = async () => {
    const token = await authenticateOnAPI();
    api
      .get('/parental-consent/constraints', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response: AxiosResponse<Constraints>) => {
        setMinAge(response.data.minAge);
      })
      .catch(() => {
        setMinAge(defaultValue.minAge);
      });
  };

  useEffect(() => {
    getMinAgeParental();
  }, []);

  const urlPrivacyPolicy =
    !user.privacyPolicy || user.privacyPolicy.jurisdiction === 'LGPD'
      ? `https://privacidade.globo.com/privacy-policy`
      : 'https://privacidade.globo.com/int/pt-br/politica-de-privacidade/';

  const redirectToPolicyPrivacy = () => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.CommunicationPreferences,
      event_action: Actions.ClickPolicyPrivacyCommunication,
      bd_suser_code: user?.globoId,
    });
  };

  return (
    <>
      {openModal !== false && (
        <Modal maxWidth="360px">
          <ModalBody>
            <ModalHeader>
              <TextHeaderModal>{messageFields.dialogTitle}</TextHeaderModal>
            </ModalHeader>

            {messageFields.type === 'cellphone' ? (
              <ModalParaghaph>{messageFields.dialogDescription}</ModalParaghaph>
            ) : (
              <ModalParaghaph>
                {messageFields.dialogDescription}
                <PolicyPrivacy
                  href={urlPrivacyPolicy}
                  target="_blank"
                  onClick={redirectToPolicyPrivacy}
                  rel="noreferrer"
                >
                  <b>Política de Privacidade.</b>
                </PolicyPrivacy>
              </ModalParaghaph>
            )}
            <Formik
              enableReinitialize
              initialValues={userData}
              validationSchema={validationSchema(minAge)}
              onSubmit={values => {
                handleFormSubmit(values, userData);
              }}
            >
              {({ handleSubmit }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    {(messageFields.type === 'cellphone' ||
                      messageFields.type === 'confirmMobilePhone') && (
                      <PhoneForm
                        title=""
                        user={user}
                        isIntervention="true"
                        width="100%"
                        onMobilePhoneConfirmResult={() => {
                          if (onConfirm) {
                            onConfirm();
                          }
                        }}
                        onConfirm={() => {
                          closeModal(false);
                          context.setContext(false);
                        }}
                      />
                    )}

                    {(messageFields.type === 'docNumber' ||
                      messageFields.type === 'confirmDocNumber') && (
                      <DocumentForm
                        title=""
                        user={user}
                        isIntervention
                        isInterventionFlow
                        width="100%"
                        onConfirmResult={() => {
                          if (onConfirm) {
                            onConfirm();
                          }
                        }}
                        onConfirm={() => {
                          closeModal(false);
                          if (onConfirm) {
                            onConfirm();
                          }
                          context.setContext(false);
                        }}
                      />
                    )}
                  </form>
                );
              }}
            </Formik>
            <ModalButtons>
              <Button
                variant="primary"
                width="100%"
                onClick={() => {
                  window.dataLayer.push({
                    event: 'customEventUserInteraction',
                    event_category: GetInterventionCategory(
                      user,
                      messageFields,
                    ),
                    event_action: Actions.ClickSkip,
                    event_label: 'Tela de Intervencao',
                    bd_suser_code: user?.globoId,
                  });
                  closeModal(false);
                  context.setContext(false);
                }}
              >
                Prefiro deixar para depois
              </Button>
            </ModalButtons>
          </ModalBody>
        </Modal>
      )}
    </>
  );
}
